import React, { useState, useEffect } from 'react'
import styles from "./styles.module.css";
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'

import { getUniversity } from '../../../actions/report';

import BtnBack from '../helper/btnBack/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';

import bg from '../../../assets/dashboard/background_1.png'
import logo_big from '../../../assets/dashboard/logo_big.png'
import { BACKEND_URL_PREFIX } from '../../../utils/const';

const Faculties = ({
  university,
  getUniversity,
  match,
  location,
  history
}) => {
  
  const [uni, setUni] = useState(null);
  const [facultyList, setFacultyList] = useState(null);
    
  const { id } = match.params

  useEffect(() => {
      getUniversity();
  }, []);

  useEffect(() => {
    if (university && university.length > 0 && id != null && id != 'all') {
      const [one, two] = id.split('_');
      const univer = two ? university[one].branches[two] : university[one]
      const prefix = univer?.api_url
      if (prefix?.length > 1) {
        const url = `${prefix}faculty`
        fetch(url)
            .then(resp => resp.json())
            .then(data => setFacultyList(data))
      }
      
      setUni(univer)
    }
      if (id == 'all') {
        const url = `${BACKEND_URL_PREFIX}/faculty/cathedras`
        fetch(url)
        .then(resp => resp.json())
        .then(data => setFacultyList(data))
    }

  }, [university]);
  
  const renderFacult = (item) => {
    const fuckMode = !!item.idfaculty
    const name = fuckMode ? item.faculty : item.cathedra
    const facLink = `${location.pathname}/${item.idfaculty}/0`
    const cathLink = `${location.pathname}/0/${item.idcathedra}` 

    const link = fuckMode ? facLink : cathLink
    return (
      <div className={styles.wrapperList} key={name}>
        <Link to={link} className={styles.itemLink}>
          <div className={styles.item}>
            <span>{name}</span>
          </div>
        </Link>
      </div>
    )
  }


  return (
    <div className={styles.wrapper}>
      <img src={bg} className={styles.bg}/>
      <div className={styles.logo_bigWrapper}>
          <img src={logo_big} className={styles.logo_big}/>
      </div>
      <GetHeader title={<>ФАКУЛЬТЕТЫ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ <br/> {uni?.name}</>}/>

      <div className={styles.wrapperBlock}>
        {facultyList?.map(renderFacult)}
      </div>

      <BtnBack/>
    </div>
  )
}


const mapStateToProps = (state) => ({
  university: state.report.university
  });
  
  export default connect(mapStateToProps, { 
    getUniversity
  })(Faculties);